import e from "react";
const r = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 12", width: "12", height: "12" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement(
      "g",
      null,
      e.createElement("path", { d: "M159,30 C155.685908,30 153,32.6859076 153,36 C153,39.3142428 155.685908,42 159,42 C162.31304,42 165,39.3142428 165,36 C165,32.6859076 162.31304,30 159,30 L159,30 Z M161.815633,38.1901541 C162.008794,38.3827133 162.008794,38.6949267 161.815633,38.8882375 C161.623525,39.081398 161.310259,39.081398 161.118001,38.8882375 L159,36.7694852 L156.881849,38.8882375 C156.689741,39.081398 156.376475,39.081398 156.184367,38.8882375 C155.991056,38.695077 155.991056,38.3828636 156.184367,38.1901541 L158.37392,36 L156.184367,33.8098459 C155.991056,33.6177377 155.991056,33.3061255 156.184367,33.1117625 C156.376475,32.9196543 156.689741,32.9196543 156.881849,33.1117625 L158.999399,35.2305148 L161.118151,33.1117625 C161.310259,32.9196543 161.623525,32.9196543 161.815784,33.1117625 C162.008944,33.304923 162.008944,33.6177377 161.815784,33.8098459 L159.62608,36 L161.815633,38.1901541 L161.815633,38.1901541 Z", transform: "translate(-153 -30)" })
    )
  )
);
r.displayName = "CircleX12x12";
export {
  r as I
};
//# sourceMappingURL=CircleX12x12-CLsP0OlE.mjs.map
